import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Calendar, ArrowRight } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Link } from 'react-router-dom';

const CTABanner = ({ variant = 'default' }) => {
  if (variant === 'phone') {
    return (
      <section className="py-12 bg-gradient-to-r from-cyan-500/20 to-purple-500/20 border-y border-white/10">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-cyan-500 flex items-center justify-center animate-pulse">
                <Phone size={24} className="text-black" />
              </div>
              <div>
                <p className="text-white font-semibold text-lg">Call Us Today!</p>
                <p className="text-cyan-400 font-mono text-xl">{companyInfo.phone}</p>
              </div>
            </div>
            <div className="bg-yellow-500 text-black px-6 py-3 rounded-full font-bold text-sm tracking-wider animate-bounce">
              🎉 GET 20% OFF YOUR FIRST SERVICE!
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (variant === 'consultation') {
    return (
      <motion.section 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="py-16 bg-white/5"
      >
        <div className="container mx-auto px-4 lg:px-8">
          <div className="bg-gradient-to-br from-cyan-500/10 to-purple-500/10 border border-white/10 rounded-2xl p-8 lg:p-12 text-center">
            <Calendar size={48} className="text-cyan-400 mx-auto mb-6" />
            <h2 className="section-heading text-white mb-4">
              Ready to Grow Your Business?
            </h2>
            <p className="body-large text-white/60 mb-8 max-w-2xl mx-auto">
              Schedule a free consultation with our experts. No commitment, just valuable insights for your business.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/#contact"
                className="cta-button bg-cyan-500 text-black border-cyan-500 hover:bg-cyan-400 flex items-center gap-2"
              >
                <Calendar size={16} />
                Schedule Free Consultation
              </Link>
              <a
                href={`tel:${companyInfo.phone}`}
                className="cta-button bg-transparent text-white border-white/30 hover:border-cyan-400 hover:text-cyan-400 flex items-center gap-2"
              >
                <Phone size={16} />
                {companyInfo.phone}
              </a>
            </div>
            <p className="mt-6 text-yellow-400 font-semibold">
              📞 Call now and get 20% OFF your first service!
            </p>
          </div>
        </div>
      </motion.section>
    );
  }

  // Default banner
  return (
    <section className="py-16 bg-cyan-500">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div>
            <h2 className="section-heading text-black mb-2">
              Let&apos;s Build Something Amazing Together
            </h2>
            <p className="text-black/70 text-lg">
              Get a free quote today and see how we can help grow your business.
            </p>
          </div>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/#contact"
              className="cta-button bg-black text-white border-black hover:bg-black/80 flex items-center gap-2"
            >
              Get Free Quote
              <ArrowRight size={16} />
            </Link>
            <a
              href={`tel:${companyInfo.phone}`}
              className="cta-button bg-transparent text-black border-black hover:bg-black/10 flex items-center gap-2"
            >
              <Phone size={16} />
              Call for 20% OFF
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
